<template>
        <div class="warp" ref="warp">
          <div class="retrieve border" ref="condition">
                <div class="left">
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="selectType" placeholder="请选择" @change="onChangeValue" size="small" clearable>
                            <el-option
                              v-for="item in options"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value" 
                            />
                        </el-select>
                        <template v-if="selectType === 'operType'">
                            <el-select v-model="sendInfo[selectType]" placeholder="请选择" size="small" clearable>
                              <el-option
                                v-for="item in typeOptions"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value" 
                              />
                            </el-select>
                        </template>
                        <el-input v-else v-model="sendInfo[selectType]" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <div class="child">
                        <span class="name">操作日期</span>
                        <el-date-picker style="width:250px;"
                          size="small"
                          v-model="dateOfOperation"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          type="datetimerange"
                          :default-time="['24:00:00','23:59:59']"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                        />
                    </div>
                    <div class="child">
                        <span class="name">操作状态</span>
                        <el-select v-model="sendInfo.operStatus" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
                    <el-button  size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              v-loading="loading"
              element-loading-text="请求中......"
              fit
              :height="bHeight"
              :header-cell-style="headerStyle"
              @sort-change="sortChange"
            >
                <el-table-column
                  label="序号"
                  type="index"
                  width="55"
                />
                <el-table-column
                  prop="userName"
                  show-overflow-tooltip
                  label="账号"
                />
                <el-table-column
                  prop="realName"
                  show-overflow-tooltip
                  label="操作人"
                />
                <el-table-column
                  show-overflow-tooltip
                  sortable
                  label="操作时间"
                  prop="createTime"
                />
                <el-table-column
                  prop="operModule"
                  show-overflow-tooltip
                  label="系统模块"
                />
                <el-table-column
                  prop="operTypeStr"
                  show-overflow-tooltip
                  label="操作类型"
                />
                <el-table-column
                  prop="operStatusStr"
                  show-overflow-tooltip
                  label="操作状态"
                />
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="sendInfo.currentPage"
                  :page-sizes="[5, 10, 15, 20]"
                  :page-size="sendInfo.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalPage"
                />
            </div>
        </div>
</template>

<script>
export default {
  data() {
    return {
      sendInfo: {
        pageSize: 10,
        currentPage: 1,
        property: null,//排序字段
        direction: null,//排序方式
        operStatus: void 0,
        userName: void 0,
        realName: void 0,
        operModule: void 0,
        operType: void 0,
        startDate: void 0,
        endDate: void 0
      },
      tableData: [],
      totalPage: 0,
      bHeight: void 0,
      loading: false,
      statusList: [{name: '成功', value: '0'},{name: '失败', value: '1'}],
      selectType: void 0,
      dateOfOperation: void 0, // 操作日期
      options: [{
        label: '账号',
        value: 'userName'
      },{
        label: '操作人',
        value: 'realName'
      },{
        label: '系统模块',
        value: 'operModule'
      },{
        label: '操作类型',
        value: 'operType'
      }],
      typeOptions: []
    }
  },
  async created() {
    const { code, data } = await this.$axiosz.get(`backstage/sysDict/OPERATE_TYPE`)
    if (code === 200) this.typeOptions = data || []
  },
  mounted() {
    const that = this
    that.getData();
    let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
    that.bHeight = document.body.clientHeight - 64  - bh 
    that.doLayout()
    window.onresize = () => {
      return (() => {
        that.$nextTick(() => {
            bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
            that.bHeight = document.body.clientHeight - 64  - bh 
            that.doLayout()
        })
      })()
    }
  },
  methods: {
    /* 重置上次选中的类型值 */
    onChangeValue(val) {
      const arr = this.options.filter(a => a.value !== val).map(b => b.value)
      arr.forEach(key => {
        this.sendInfo[key] = void 0
      })
    },
    /* 获取列表数据 */
    getData() {
      const that = this
      if (that.dateOfOperation && that.dateOfOperation.length) {
        that.sendInfo.startDate = that.dateOfOperation[0]
        that.sendInfo.endDate = that.dateOfOperation[1]
      }
      that.loading = true
      that.$axiosc.post(`backstage/syslog/list?${that.$qs.stringify(that.sendInfo)}`,).then((r) => {
        that.loading = false
        if (r.code == 200) {
          that.tableData = r.data.content;
          that.totalPage = r.data.totalElements;
        } else {
          that.$alert(r.msg)
        }
      }).catch(() => {
        that.loading = false
      })
    },
    //重置
    onReset() {
      this.sendInfo = Object.assign(this.sendInfo, {
        pageSize: 10,
        currentPage: 1,
        property: null,//排序字段
        direction: null,//排序方式
        operStatus: void 0,
        userName: void 0,
        realName: void 0,
        operModule: void 0,
        operType: void 0,
        startDate: void 0,
        endDate: void 0
      })
      this.selectType = void 0
      this.dateOfOperation = void 0
      this.getData()
    },
    //切换每页显示条数
    handleSizeChange(val) {
      this.sendInfo.pageSize = val;
      this.getData();
    },
    //切换页码
    handleCurrentChange(val) {
      this.sendInfo.currentPage = val;
      this.getData();
    },
    //表格排序事件
    sortChange({column, prop, order}) {
      if (order == 'ascending') {
        order = 'asc';
      } else {
        order = 'desc';
      }
      this.sendInfo.property = prop;
      this.sendInfo.direction = order;
      this.getData();
    },
    // 表头样式回调
    headerStyle() {
      return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
    },
    doLayout() {
      this.$nextTick(() => {
        if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
          this.$refs.multipleTable.doLayout()
        }
      })
    },
  }
}
</script>

<style scoped="scoped" lang="scss">
    .forms {
        .child {          
            .remark {
                /deep/ .el-textarea__inner {
                    min-height: 122px !important;
                }
            }
            .name {
                width: 123px;
                text-align: right;
            }
            .content{
              .el-input{
                max-width:400px !important;
              }
            }
        }
        .hint{
          margin-top:40px !important
        }
    }
    .left{
      .child{
        margin-top:0 !important;
      }
    }
.detail{
   padding:20px;
  .step{
    &_title{
      font-size: 14px;
      font-weight: 600;
      color:#666;
    }
    &_desc{
      font-size: 12px;
      color:#999;
      margin-top:5px;
    }
    &_tip{
      width:100%;
      height: 78px;
      background: rgba(255, 245, 230, 1);
      border: 1px solid rgba(255, 235, 204, 1);
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left:20px;
      margin-top:20px;
      &_title{
        font-size: 14px;
        color:#666;
      }
    }
    &_error{
      &_title{
        font-size: 13px;
        font-weight: 700;
        color: #666;
        span{
          color: #19BE6B;
          font-weight: 400;
        }
        .red{
          color: red;
        }
      }
      &_lists{
        border:1px solid #ccc;
        background: rgba(249, 249, 249, 1);
        padding:20px;
        &_title{
          font-size: 14px;
          font-weight: 700;
          line-height: 24px;
        }
        &_item{
          font-size: 12px;
          line-height: 20px;
          margin-top:10px;
        }
      }
    }
  }
  .step_success{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-items: center;
      justify-content:center;
      min-height:300px;
      .el-icon-success{
        font-size: 48px;
        color:#67c23a;
      }
      &_title{
        font-size: 16px;
        margin-top:20px;
        font-weight: bold;
      }
      &_info{
        margin-top:10px;
        font-size: 14px;
      }
  }
  .step_percentage{
    min-height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .el-progress{
      width:100%;
    }
    &::v-deep{
      .el-progress__text{
        position:absolute;
        top:-25px;
        left:48%;
      }
    }
    &_tip{
      margin-top:20px;
      text-align: center;
      color:#888;
    }
  }
}
::v-deep{
  .el-tab-pane{
    .el-button{
      width:10%;
      margin-bottom:5px;
    }
    .el-button+.el-button{
      margin-left:0;
    }
  }
  .el-icon-dot{
  width:15px;
  height: 15px;
  border-radius: 50%;
  background: #ccc;
}
.is-finish{
  .el-icon-dot{
    background:$primary;
  }
}
.el-step__icon.is-icon{
  width:15px;
}
.el-step__title{
  font-size: 12px;
}
.el-descriptions-item__label{
  vertical-align:middle;
  text-align: center !important;
  width:10% !important;
}

}
.super_radio{
  display: block;
  width:80%;
  margin:0 auto;
  .el-radio{
    width:120px;
    margin-bottom:10px;
  }
  .el-radio:nth-child(3n){
    margin-right: 0 !important;
  }
}
</style>